import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import './App.scss';
import { routes } from './routes';
import { getMyProfile } from './store/actions/user.action';
import './styles/index.scss';
import { SessionManger } from './utils/SessionManger';
import { Logout, history, isUserLoggedIn } from './utils/handler';
import Footer from './views/layouts/footer';
import Header from './views/layouts/header';
// import SignUpAndIntro from './views/registrar-integrations/pitchPage';
import RewampedLanding from './views/registrar-integrations/rewampedLanding';
import RewampedHeader from 'views/layouts/rewampedHeader';
import RewampedFooter from 'views/layouts/rewampedFooter';
import { routeObject } from 'store/storeTypes';

const BBApp: React.FC = (): JSX.Element => {
  const [hideLayout, setHideLayout] = useState(false);
  const [knownRoute, setKnownRoute] = useState(true);
  const [showRewampedHeader, setShowRewampedHeader] = useState(false);
  SessionManger();
  useEffect(() => {
    if (isUserLoggedIn()) {
      let res = getMyProfile();
      if (!res) Logout();
    }
    checkRouter(history.location);
    history.listen((location: typeof history) => {
      checkRouter(location);
    });
  }, []);

  const checkRouter = (location: typeof history) => {
    const routerObj = _.find(routes, (route) => route.path?.toLowerCase() === location.pathname.toLowerCase());
    setShowRewampedHeader(routerObj.path === '/' || routerObj.path === '/calendly');
    window.scrollTo(0, 0);
    setKnownRoute(routerObj ? true : false);
    if (routerObj) setHideLayout(routerObj.hideLayout ? true : false);
  };

  const getMainClass = (props: routeObject) => {
    if (showRewampedHeader) return 'w100';
    if (props.hideMain) return 'w100';
    if (hideLayout) return 'main top-without-header';
    return 'main';
  };

  return (
    <>
      <Router history={history}>
        <div className="app">
          {!hideLayout && showRewampedHeader && <RewampedHeader />}
          {!hideLayout && !showRewampedHeader && <Header />}
          {knownRoute === false ? (
            <RewampedLanding />
            // <main className={'main'}>
            //   <SignUpAndIntro />
            // </main>
          ) : (
            <Switch>
              <Redirect from="/sell-domain" to="/sell" />
              {routes.map((props, index) => (
                <Route
                  key={index}
                  exact
                  path={props.path}
                  render={() => {
                    return (
                      <>
                        <main className={getMainClass(props)}>{props.isPrivateRoute ? isUserLoggedIn() ? <props.Component {...props} /> : <Redirect to={{ pathname: '/' }} /> : <props.Component {...props} />}</main>
                      </>
                    );
                  }}
                />
              ))}
              <Route path="*">
                <Redirect to="/" />
              </Route>
            </Switch>
          )}
          {!hideLayout && showRewampedHeader && <RewampedFooter />}
          {!hideLayout && !showRewampedHeader && <RewampedFooter />}
        </div>
      </Router>
    </>
  );
};

export default BBApp;
